import React, { FC } from "react";
import { OctaveOptions } from "../models/customTypes";
import "./OctaveOffsetButtons.scss";

type OctaveOffsetProps = {
  offset: number;
  onIncrement: () => void;
  onDecrement: () => void;
  numOctaves: OctaveOptions;
};

const OctaveOffsetButtons: FC<OctaveOffsetProps> = ({
  offset,
  onIncrement,
  onDecrement,
  numOctaves,
}) => {
  const getOctaveOffsetBySize = (): number => {
    if (numOctaves === 6) return 1;

    return 0;
  };

  return (
    <div className="settings-row octave-offset-buttons">
      <span className="control-label">Octave Offset:</span>
      <div className="settings-row-controls">
        <button
          className="btn btn-light btn-extra-small settings-action-btn"
          onClick={onIncrement}
          disabled={offset >= 3 + getOctaveOffsetBySize()}
        >
          Octave Up
        </button>
        <button
          className="btn btn-light btn-extra-small settings-action-btn"
          onClick={onDecrement}
          disabled={offset <= 1}
        >
          Octave Down
        </button>
      </div>
    </div>
  );
};

export default OctaveOffsetButtons;
